import type { FeatureCollection } from 'geojson'
import { useEffect, useMemo, useState } from 'react'
import StaticMap, { Layer, Source } from 'react-map-gl'
import { MAPBOX_ACCESS_TOKEN } from '~/constants'
import { useListingPointLayerStyle } from '~/hooks/map'
import { Listing } from '~/models'

export default function ListingStaticMap({ listing }: { listing: Listing }) {
  const [isLoaded, setIsLoaded] = useState(false)
  const pointLayer = useListingPointLayerStyle()

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  const listingPoint = useMemo(() => {
    return {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            ...listing.location,
            type: 'Point',
          },
          properties: {
            ...listing,
          },
        },
      ],
    } as FeatureCollection
  }, [listing])

  if (!isLoaded) {
    return null
  }

  return (
    <StaticMap
      initialViewState={{
        longitude: listing.location.coordinates[0],
        latitude: listing.location.coordinates[1],
        zoom: 16,
      }}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      customAttribution="View by Resimplifi"
      mapStyle="mapbox://styles/cameron-resimplifi/clkkb5n0y00wg01p22en48v6w"
      style={{ width: '100%', height: '100%' }}>
      <Source type="geojson" data={listingPoint}>
        <Layer {...pointLayer} />
      </Source>
    </StaticMap>
  )
}
